/* assets/src/viewer/effects/optional.js
 * RIABILITA optional -> 3D (in F5 era morto: asgApplyViewerEffects early-return :921,
 * collectViewerEffects early-return app.js). Legge config.__viewerEffects e aggiunge
 * elementi visibili (LED, vetrate, zip) al gruppo modello. NON tocca il prezzo.
 */
import * as THREE from 'three';
import { disposeGroup } from '../perf/disposal.js';

export class OptionalEffects {
  constructor(viewer) {
    this.viewer = viewer;
    this.model = null;
    this.group = null;
  }

  apply(config, model, dims) {
    if (!model) return;
    const fx = config && config.__viewerEffects ? config.__viewerEffects : null;
    const lights = !!(fx && fx.add_lights && fx.add_lights.active);
    const glass = !!(fx && fx.add_glass && fx.add_glass.active);
    const zip = !!(fx && fx.add_zip && fx.add_zip.active);

    // rimuove il sottogruppo effetti precedente
    if (this.group && this.model) {
      this.model.group.remove(this.group);
      disposeGroup(this.group);
      this.group = null;
    }
    this.model = model;

    if (!lights && !glass && !zip) { this.viewer.requestRender(); return; }

    this.group = new THREE.Group();
    this.group.name = 'asg-viewer-effects';

    const box = new THREE.Box3().setFromObject(model.group);
    const topY = box.isEmpty() ? 2.5 : box.max.y;
    const isNight = this.viewer.sceneManager.lighting.mode === 'night';

    if (lights) this._addLights(dims, topY, isNight);
    if (glass) this._addGlass(dims, topY);
    if (zip) this._addZip(dims, topY);

    model.group.add(this.group);
    this.viewer.requestRender();
  }

  _addLights(dims, topY, isNight) {
    const inset = 0.18;
    const y = Math.max(0.2, topY - 0.24);
    const mat = new THREE.MeshStandardMaterial({
      color: 0xfaf3d0,
      emissive: new THREE.Color(0xfff1ba),
      emissiveIntensity: isNight ? 3.2 : 1.8,
      roughness: 0.3, metalness: 0, transparent: true, opacity: 0.98, toneMapped: false,
    });
    const t = 0.012; const dpt = 0.022;
    const fbLen = Math.max(0.55, dims.w - inset * 2);
    const sdLen = Math.max(0.45, dims.d - inset * 2);
    const front = new THREE.Mesh(new THREE.BoxGeometry(fbLen, t, dpt), mat);
    front.position.set(0, y, dims.d / 2 - inset);
    const back = front.clone(); back.position.z = -dims.d / 2 + inset;
    const left = new THREE.Mesh(new THREE.BoxGeometry(sdLen, t, dpt), mat);
    left.rotation.y = Math.PI / 2; left.position.set(-dims.w / 2 + inset, y, 0);
    const right = left.clone(); right.position.x = dims.w / 2 - inset;
    [front, back, left, right].forEach((m) => this.group.add(m));

    if (isNight) {
      const pl = new THREE.PointLight(0xffe9b0, 6, Math.max(dims.w, dims.d) * 1.4, 2);
      pl.position.set(0, y - 0.1, 0);
      this.group.add(pl);
    }
  }

  _addGlass(dims, topY) {
    const mat = new THREE.MeshPhysicalMaterial({
      color: 0xeaf2f7, metalness: 0, roughness: 0.06, transmission: 0.92, thickness: 0.3,
      ior: 1.45, transparent: true, envMapIntensity: 1.0,
    });
    const h = topY - 0.1;
    const left = new THREE.Mesh(new THREE.BoxGeometry(0.02, h, dims.d - 0.2), mat);
    left.position.set(-dims.w / 2 + 0.08, h / 2, 0);
    const right = left.clone(); right.position.x = dims.w / 2 - 0.08;
    [left, right].forEach((m) => { m.castShadow = false; m.receiveShadow = false; this.group.add(m); });
  }

  _addZip(dims, topY) {
    const mat = new THREE.MeshPhysicalMaterial({
      color: 0x3a3f47, roughness: 0.9, metalness: 0.0, side: THREE.DoubleSide,
      transparent: true, opacity: 0.92,
    });
    const h = topY - 0.1;
    const back = new THREE.Mesh(new THREE.PlaneGeometry(dims.w - 0.2, h), mat);
    back.position.set(0, h / 2, -dims.d / 2 + 0.05);
    this.group.add(back);
  }
}
